export default __webpack_public_path__ + "static/media/renbtc.0070ebaa.svg";